import { render, staticRenderFns } from "./ContributersTable.vue?vue&type=template&id=27afe223&scoped=true&"
import script from "./ContributersTable.vue?vue&type=script&lang=ts&"
export * from "./ContributersTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContributersTable.vue?vue&type=style&index=0&id=27afe223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27afe223",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
